// Workbench MVP Session A — static 8-node architecture topology.
// Node ids MUST match TraceStepSlaConstants.AllNodeIds on the backend. Adding
// a node here without a matching backend entry leaves it as "no data"; adding
// one on the backend without a matching entry here leaves it off the diagram.
//
// x/y are in a normalized 0..100 coordinate system so the SVG can scale with
// the container width (viewBox 0 0 100 60). The diagram flows left-to-right
// through the request path, with orchestration nodes on the top row and
// data-plane nodes on the bottom row.

export interface TopologyNode {
  id: string;
  label: string;
  x: number;
  y: number;
  description: string;
}

export interface TopologyEdge {
  from: string;
  to: string;
}

export const architectureNodes: TopologyNode[] = [
  { id: 'ingress',         label: 'Ingress',         x: 8,  y: 30, description: 'API entry — matrix.started marker.' },
  { id: 'retrieval',       label: 'Retrieval',       x: 25, y: 15, description: 'Vector search over indexed chunks.' },
  { id: 'prompt_assembly', label: 'Prompt Assembly', x: 42, y: 30, description: 'Template render + context stitching.' },
  { id: 'provider_fanout', label: 'Provider Fanout', x: 55, y: 15, description: 'Matrix fan-out across configured chat models.' },
  { id: 'provider_call',   label: 'Provider Call',   x: 68, y: 30, description: 'LLM API invocation — dominant latency.' },
  { id: 'evaluation',      label: 'Evaluation',      x: 82, y: 15, description: 'Groundedness / relevance / safety scoring.' },
  { id: 'ranking',         label: 'Ranking',         x: 82, y: 45, description: 'Deterministic scorer + tie-break.' },
  { id: 'persistence',     label: 'Persistence',     x: 95, y: 30, description: 'Postgres writes for runs, results, telemetry.' },
];

export const architectureEdges: TopologyEdge[] = [
  { from: 'ingress',         to: 'retrieval' },
  { from: 'retrieval',       to: 'prompt_assembly' },
  { from: 'prompt_assembly', to: 'provider_fanout' },
  { from: 'provider_fanout', to: 'provider_call' },
  { from: 'provider_call',   to: 'evaluation' },
  { from: 'evaluation',      to: 'ranking' },
  { from: 'ranking',         to: 'persistence' },
];

// Diagram viewBox. Height chosen so the two rows have breathing room without
// forcing a huge minHeight on the container.
export const TOPOLOGY_VIEW_W = 100;
export const TOPOLOGY_VIEW_H = 60;
